import TextAreaInput from 'components/forms/inputs/rhf-inputs/TextAreaInput';
import { ModalFooter } from 'components/modals/ModalFooter';
import { ModalHeader } from 'components/modals/ModalHeader';
import { useForm } from 'react-hook-form';
import { useRevertClientIdentificationReceiptMutation } from 'store/api/client-identifications';
import { t } from 'utils/getTranslations';
import { successAlert } from 'utils/alert';

interface FormValues {
    comment: string;
}

interface Props {
    contractId: number;
    onClose: () => void;
}

/** Puts a received client identification back to in progress, with an optional word on why. */
export function RevertReceiptDialog({ contractId, onClose }: Props) {
    const [revert, { isLoading }] = useRevertClientIdentificationReceiptMutation();
    const { control, handleSubmit } = useForm<FormValues>({ defaultValues: { comment: '' } });

    const submit = handleSubmit(async ({ comment }) => {
        try {
            await revert({ id: contractId, comment: comment.trim() || null }).unwrap();
        } catch {
            // The API layer has shown the server's reason; the dialog stays open.
            return;
        }
        successAlert(t('client-identification.receipt-reverted'));
        onClose();
    });

    return (
        <>
            <ModalHeader title={t('client-identification.revert')} onCancel={onClose} />
            <form
                noValidate
                className="flex min-h-0 flex-col gap-4 overflow-y-auto p-6"
                onSubmit={(e) => void submit(e)}
            >
                <p className="text-body1 m-0">{t('client-identification.revert-intro')}</p>
                <TextAreaInput
                    control={control}
                    name="comment"
                    label="client-identification.comment-optional"
                    minRows={3}
                />
            </form>
            <ModalFooter
                onCancel={onClose}
                onSave={() => void submit()}
                saveButtonTextId="client-identification.revert"
                disableSave={isLoading}
            />
        </>
    );
}
